import React from "react";
import ImageGallery from "react-image-gallery";
import Button from "react-bootstrap/Button";

import { getHomeImages } from "../services/aircraftImageService";
import { getModelKitsCount } from "../services/aircraftModelsService";
import facebookIcon from "../images/facebook icon.jpeg";
import { getCurrentUser, saveFaceBookUrl } from "../services/authService";
import { convertAircraftImages } from "../converImagesToJpg";

class Home extends React.Component {
	state = {
		images: [],
		kitCount: 0,
		user: {},
		facebook_url: "",
	};

	async componentDidMount() {
		const cnt = await getModelKitsCount();

		const data = await getHomeImages(6);
		//console.log(data);
		const user = await getCurrentUser();

		const images = data.map((image) => ({
			original: "data:image/jpg;base64," + image.aircraft_image,
			thumbnail: "data:image/jpg;base64," + image.aircraft_image,
		}));
		this.setState({
			user: user,
			images,
			kitCount: cnt,
			facebook_url: user === null ? "" : user.facebook_url,
		});
	}

	handleAddFacebookLink = async () => {
		const url = window.prompt("Enter your facebook link?");
		if (url !== null) {
			const usr = this.state.user;
			await saveFaceBookUrl(usr.id, url);
			const user = await getCurrentUser();
			this.setState({ user: user, facebook_url: url });
		}
	};

	handleConvert = async () => {
		await convertAircraftImages();
		window.alert("DONE!!!!!!");
	};

	render() {
		const { images, kitCount, facebook_url, user } = this.state;

		return (
			<React.Fragment>
				{/* <button onClick={this.handleConvert}>Convert Images</button> */}
				<div className="home-gallery">
					<ImageGallery items={images} />
					<p style={{ textAlign: "right", marginTop: "30px" }}>
						<i>This site has {kitCount} kits.</i>
					</p>
					<div style={{ border: "1px solid darkgray", padding: "20px" }}>
						<h4
							style={{
								marginTop: "10px",
								marginBottom: "20px",
								textDecoration: "underline",
							}}
						>
							About
						</h4>
						<p style={{ textAlign: "justify", marginBottom: "30px" }}>
							<i>
								This app has been developed to promote and enhance the hobby of
								building models. All Company Names and logos are the property of
								the registered trademark owner and are used in this application
								for identification and reference only. This app has been created
								and published under the provisions of Australian Copyright Law.
							</i>
						</p>
						<h5>WORLD WAR II Aircraft</h5>
						<ul>
							<li>
								All <b>Manned</b> aircraft that served a <b>Military purpose</b>{" "}
								during the <b>WWII era 1939-1945</b>.
							</li>
							<li>
								Excludes <b>Military Prototypes of this era</b>.
							</li>
							<li>
								Separates Variants that are of a significant change in
								construction/production/role.
							</li>
						</ul>
						<h5>SCALE MODELLING</h5>
						<ul>
							<li>
								Includes <b>Full Kits</b> only.
							</li>
							<li>
								Excludes <b>Coversion Kits and/or Detail Kits</b>.
							</li>
							<li>
								Includes models representing Military <b>aircraft only</b>.
							</li>
							<li>
								Excludes models representing WWII protoypes not produced or
								involved in Military action.
							</li>
							<li>
								Excludes Kits of Aircraft relating only to other conflicts.ie
								Korean War.
							</li>
							<li>
								To source Molding/Reboxing for individual kits, serial numbers,
								check out <b>www.scalemates.com</b>.
							</li>
							<li>
								Where confirmed, <b>Future Releases</b> have been included.
							</li>
							<li>
								Where confirmed, <b>Planned Releases that never eventuated</b>{" "}
								have obviously not been included
							</li>
						</ul>
						<p>
							<b>Note: Information updated monthly</b>.
						</p>
						<p>
							Contact:{" "}
							<a href="mailto:kevindavson980@gmail.com">
								kevindavson980@gmail.com
							</a>
						</p>
						<div className="horizontalAlign">
							<img
								src={facebookIcon}
								alt="facebook icon"
								style={{ height: "50px" }}
							/>
							{user !== null && facebook_url === "" ? (
								<Button
									variant="link"
									onClick={this.handleAddFacebookLink}
									size="sm"
								>
									Add Link
								</Button>
							) : (
								<>
									<a target="new" href={facebook_url}>
										{facebook_url}
									</a>
									<div style={{ marginLeft: "20px" }}>
										{user && (
											<Button
												variant="link"
												onClick={this.handleAddFacebookLink}
												size="sm"
											>
												Change Link
											</Button>
										)}
									</div>
								</>
							)}
						</div>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
			</React.Fragment>
		);
	}
}

export default Home;
